$('.section-hero .scroll-down').on('click', function (e) {
    e.preventDefault();
    let next_section = $(this).closest('section').next();
    if (next_section.length < 1) return;
    $('html,body').animate({
        scrollTop: next_section.offset().top
    }, 1200);
});